import React from "react";
import { Prettify } from "../../utils/types";
import { BaseButton } from "./BaseButton";
import { BaseButtonProps, ButtonVariant, ButtonVariantProps } from "./types";

export type ButtonProps = Prettify<
    Omit<BaseButtonProps<"button">, "as" | "variant"> & {
        /**
         * Defines button variant.
         * @default "primary"
         */
        variant?: ButtonVariant;
    }
> &
    ButtonVariantProps;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
    <BaseButton {...props} as="button" ref={ref} />
));
